import React, { cloneElement, isValidElement } from 'react';
import { useRouter } from './useRouter';
/**
 *
 * ```typescript
 * import React from "react";
 * import {  Route, Switch, useParams } from "@okapi/router-react";
 *
 * function Topics(props) {
 *  return (
 *    <Switch>
 *      <Route path={`${props.path}/:topicId`} component={Topic}/>
 *      <Route path={props.path}>
 *        <h3>Please select a topic.</h3>
 *      </Route>
 *    </Switch>
 *  );
 * }
 *
 * function Topic() {
 *  const params = useParams();
 *  return <h3>Requested topic ID: {params.topicId}</h3>;
 * }
 * ```
 */
export const Switch = ({ children, location }) => {
    const router = useRouter();
    let element = null;
    let match = [false, null];
    React.Children.forEach(children, child => {
        if (isValidElement(child) && !match[0]) {
            match = child.props.path
                ? router.matcher(child.props.path, location || router.getPath(), child.props.strict, child.props.exact)
                : [true, {}];
            if (match[0]) {
                element = child;
            }
        }
    });
    if (match[0] && element) {
        return cloneElement(element, {
            match,
        });
    }
    return null;
};
